module.exports = ".confirm-text {\n  padding: 25px 45px 15px 45px;\n  text-align: center;\n  color: #9e9e9e; }\n\n.error {\n  color: #e60000;\n  font-size: 0.5833rem;\n  margin: 0; }\n\n.ngb-modal {\n  font-size: 12px; }\n\n.ngb-modal p {\n    margin: 0; }\n\n.hipaa-form {\n  margin-left: 24px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/patient-billing-modal/patient-billing-modal.component.scss
// module id = ./src/app/shared/components/patient-billing-modal/patient-billing-modal.component.scss
// module chunks = main